import React, { useState } from "react";
import NavBar from "../NavBar.js";
// import searchWhiteIcon from "../Icon.png";
import {HRTeamsData as IncomingData} from './HRData/HRTeamsData';
export default function HRTeams() {
  const [count,setCount]=useState([]);
  const [filtr1, setFiltr1] = useState("");
  const [filtr2, setFiltr2] = useState("");

  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.deadline === '28-06-2022'
      } 
      else if (e.target.value === '2') {
        return x.deadline === '28-10-2022'
      }
      else if (e.target.value === '3')  {
        return (x.deadline !== '28-06-2022' && x.deadline !== '28-10-2022')

      }
    }));
    };

  const handleFilter2 = (e) => {
    setFiltr2(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.dept === 'Marketing'
      } 
      else if (e.target.value === '2') {
        return x.dept === 'Design'
      }
      else if (e.target.value === '3') {
        return x.dept === 'Sales'
      }
      else if (e.target.value === '4')  {
        return (x.dept !== 'Marketing' && x.dept !== 'Design' && x.dept !== 'Sales')

      }
    }));
    };
    return (
        <>
          <NavBar />
          <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Human Resource Management </span>
          <span className="color"> &#62; </span>
          <span className="color"> Teams </span>
        </p>
      </div>
            {/* {console.log(IncomingData)} */}
          <div id="Right-content-Down-First">
            <h2>Teams</h2>
            <div id="Right-content-Down-Filters">
              <div
                style={{
                  "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
                  height: "80%",
                }}
              ></div>
            </div>
          </div>
          <div id="OMS-main-content">
            <div className="order-list-box" style={{ width: "99%" }}>
              <div id="click-data">
                <p>Active</p>
                <p>Resigned</p>
                <p>Terminated</p>
              </div>
              <div className="order-list-input-box">
                <div className="order-list-input-left">
                  <input type="text"
                  placeholder="Enter ID Code or name to search..."
                  onChange={(val) => {
                  setCount(
                    IncomingData.filter(
                      (x) =>
                        x.id.match(val.target.value) ||
                        x.fName.match(val.target.value)
                    )
                  );
                  setFiltr1("");
                  setFiltr2("");
                }}
                   />
                  {/* <img src={searchWhiteIcon} alt="" width="" /> */}
                </div>
                <div className="order-list-input-right">
                  <select name="" id="" className="order-list-input-right-filters"
                  value={filtr1}
                onChange={handleFilter1}
                  >
                    <option value="" selected>
                      by deadline
                    </option>
                    <option value="1">28-06-2022</option>
                    <option value="2">28-10-2022</option>
                    <option value="3">other</option>
                  </select>
                  <select name="" id="" className="order-list-input-right-filters"
                  value={filtr2}
                onChange={handleFilter2}
                  >
                    <option selected>by department</option>
                    <option value="1">Marketing</option>
                    <option value="2">Design</option>
                    <option value="3">Sales</option>
                    <option value="4">other</option>
                  </select>
                </div>
              </div>
              <table className="th-light" style={{ textAlign: "center" }}>
                <tr>
                  <th>Team Code ID</th>
                  <th>Leader Name</th>
                  <th>Team Name</th>
                  <th>Department</th>
                  <th>Project Duration</th>
                  <th>Made On</th>
                  <th>Deadline</th>
                  <th>Shift</th>
                  <th>Team Name</th>
                  <th>Contact no</th>
                </tr>
                {count.length > 0 
                ?  count.map((val)=>{
                  return (
                    <tr>
                      <td>{val.id}</td>
                      <td>{val.fName}</td>
                      <td>{val.designation}</td>
                      <td>{val.dept}</td>
                      <td>{val.type}</td>
                      <td>{val.joinDate}</td>
                      <td>{val.deadline}</td>
                      <td>{val.shift}</td>
                      <td>{val.team}</td>
                      <td>{val.contact}</td>
                    </tr>
                  );
                }) : IncomingData.map((val)=>{
                  return (
                    <tr>
                      <td>{val.id}</td>
                      <td>{val.fName}</td>
                      <td>{val.designation}</td>
                      <td>{val.dept}</td>
                      <td>{val.type}</td>
                      <td>{val.joinDate}</td>
                      <td>{val.deadline}</td>
                      <td>{val.shift}</td>
                      <td>{val.team}</td>
                      <td>{val.contact}</td>
                    </tr>
                  )
                })}
                
               
              </table>
            </div>
          </div>
        </>
      );
}

{/* <div style={{fontSize:'20px',fontWeight:'bolder',marginTop:'3rem'}}>No Data Found</div> */}